import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SearchCheck, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import Breadcrumbs from "@/components/Breadcrumbs";
import StatusBadge from "@/components/StatusBadge";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data));
    else setResults([]);
  }, [q]);

  return (
    <div data-testid="search-page" className="bdx-page-enter">
      <Breadcrumbs items={[{ label: "Dashboard", to: "/" }, { label: "Search" }]} />
      <div className="border-b border-gray-300 pb-7">
        <div className="mb-3 flex items-center gap-2 text-[10px] font-semibold uppercase text-[#604184]" style={{ letterSpacing: "0.15em" }}>
          <SearchCheck size={15} strokeWidth={1.9} /> Project Search
        </div>
        <h1 className="font-heading text-3xl font-bold text-gray-950 sm:text-4xl">Search Results</h1>
        <p data-testid="search-result-summary" className="mt-2 text-sm text-gray-500">Results for “{q}” — {results ? results.length : "…"} match(es)</p>
      </div>

      <div className="mt-6 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-[0_3px_12px_rgba(16,19,21,0.055)]">
        <div className="bdx-panel-header"><h2 className="font-heading text-base font-bold text-gray-950">Matching Projects</h2></div>
        <div className="overflow-x-auto">
          <table className="bdx-table" data-testid="search-results-table">
            <thead><tr><th>Project No.</th><th>Type</th><th>Address</th><th>Status</th></tr></thead>
            <tbody>
              {results?.length === 0 && <tr><td colSpan={4} className="py-14 text-center text-gray-400">No matching projects</td></tr>}
              {results?.map((p) => (
                <tr key={p.id}>
                  <td><Link data-testid={`search-result-${p.project_number}`} to={`/projects/${p.id}`} className="inline-flex min-w-12 items-center justify-center rounded-md border border-[#d9cde5] bg-[#f3eff7] px-2.5 py-1.5 font-mono-data text-xs font-semibold text-[#604184]">{p.display_reference || p.project_number}</Link></td>
                  <td><span className="rounded border border-gray-200 bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600">{p.project_type}</span></td>
                  <td><Link data-testid={`search-result-address-${p.project_number}`} to={`/projects/${p.id}`} className="group flex min-w-[260px] items-center justify-between gap-4 font-semibold text-gray-950"><span>{p.label}</span><ChevronRight size={15} className="text-gray-300 transition-transform group-hover:translate-x-0.5 group-hover:text-[#604184]" /></Link></td>
                  <td><StatusBadge status={p.archived ? "Archived" : p.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}